<div class="d-block position-absolute top-0 start-0 w-100 h-100 overflow-hidden">
  <!-- Sidebar -->
  <div class="sidenav d-none d-md-block"></div>

  <!-- Main Content -->
  <div class="main bg-white">
    <div class="login-form-container">
      <img src="./assets/images/SmartDukaan_Logo_Transparent.png" style="width: 114px;  " loading="lazy">
      <div class="login-form mt-3">
        <form>
          <!-- Heading -->
          <div class="text-center mb-4">
            <h3>Welcome to <span class="fw-bold text-uppercase">Smart<span class="text-danger">Dukaan</span></span></h3>
            <p class="fs-6 fw-light">Login or Signup to continue</p>
          </div>

          <!-- Mobile Number -->
          <div class="form-group">
            <label for="mobile" class="fs-12 grey-color pb-1">Enter your Mobile Number <span class="brand-color">*</span></label>
            <input id="mobile" name="mobile" type="number" class="form-control custom-form text-black-50" [(ngModel)]="user.mobile" maxlength="10" placeholder="Mobile Number" required>
          </div>

          <!-- OTP Input -->
          <div class="form-group" *ngIf="user.referenceId">
            <label for="otp" class="fs-12 grey-color pb-1">Enter your OTP <span class="brand-color">*</span></label>
            <input id="otp" name="otpCode" type="number" class="form-control custom-form text-black-50" [(ngModel)]="user.otpCode" maxlength="5" placeholder="Enter Your OTP" required>
          </div>

          <!-- Terms and Conditions -->
          <div class="fs-12 grey-color pt-1">
            By continuing, I agree to the
            <span class="brand-color" (click)="goToPage('policy/terms')">Terms of Use</span> &
            <span class="brand-color" (click)="goToPage('policy/privacy-policy')">Privacy Policy</span>
          </div>

          <!-- Submit Button -->
          <div class="d-grid mt-4">
            <button class="btn btn-black text-white brand-bg border-light" type="button" (click)="signUpOrLogin()">Continue</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
